export const boldberries = {
  name: 'Bold Berries',
  color: [0.796078431372549, 0, 0, 1],
  bg: [0.3137254901960784, 0.19215686274509805, 0.1843137254901961, 1],
  grid1: [0.8941176470588236, 0.9176470588235294, 0.5490196078431373, 1],
  grid2: [0.24705882352941178, 0.4235294117647059, 0.27058823529411763, 1],
}
